import { UploadWindowController } from '../controller/UploadWindowController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { MAX_FILES_NUMBER } from '../types';

export class UploadWindowWebComponent extends BaseWebComponentElement {
  private _files: File[] = [];
  private _maxFilesSize: number = 0;

  controller: UploadWindowController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: UploadWindowController,
    });
  }

  get streamId(): string {
    return this.getAttribute('data-stream-id') ?? '';
  }

  set streamId(value: string | null) {
    this.setAttribute('data-stream-id', value || '');
  }

  get path(): string {
    return this.getAttribute('data-path') ?? '';
  }

  set path(value: string) {
    this.setAttribute('data-path', value);
  }

  get files(): File[] {
    return this._files;
  }

  set files(value) {
    this._files = value;
  }

  set maxFilesSize(value: number) {
    this._maxFilesSize = value
  }

  get maxFilesSize(): number {
    return this._maxFilesSize;
  }

  get filesSize(): number {
    return this._files.reduce((sum, file) => {
      sum += file.size;
      return sum;
    }, 0);
  }

  get filesNumber(): number {
    return this._files.length;
  }

  get filesNames(): string[] {
    return this._files.map(file => file.name);
  }

  isValid() {
    const filesNames = this.filesNames;
    return (
      this.files.length > 0 &&
      this.filesSize <= this.maxFilesSize &&
      this.filesNumber <= MAX_FILES_NUMBER &&
      this.filesSize > 0 &&
      this.controller.view.dom.$uploadPathField.valid &&
      new Set(filesNames).size === filesNames.length // check if there is no duplicates
    );
  }

  async validate() {
    await this.controller.validateUploadPath();
  }

  setUploadPathReadonly(state) {
    this.controller.setPathReadOnly(state);
  }
}
